/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/dialogs/nachliefern-multi-frage/shop.dialogs.nachliefern-multi-frage.component.ts.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {WarenkorbEntry} from '../../../../models/warenkorb-entry';
import {MerklistEntry} from '../../../../models/merklist-entry';

/**
 * Zweck: Beschreibt class ShopDialogsNachliefernMultiFrageComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    templateUrl: 'shop.dialogs.nachliefern-multi-frage.component.html',
    styleUrls: ['shop.dialogs.nachliefern-multi-frage.component.scss'],
    standalone: false
})
export class ShopDialogsNachliefernMultiFrageComponent implements OnInit {

  nachliefernChecked = {};

  nachliefernCheckedCounter = 0;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public dialogRef: MatDialogRef<ShopDialogsNachliefernMultiFrageComponent>,
              @Inject(MAT_DIALOG_DATA) public messages: {
                title: string, msg: string, entry: WarenkorbEntry | MerklistEntry
              }[]) {
  }

/**
 * Beschreibt Methode changeNachliefernChecked und ihren Rückgabevertrag.
 */
  changeNachliefernChecked() {
    let c = 0;
    Object.keys(this.nachliefernChecked).forEach(k => {
      if (this.nachliefernChecked[k] == true) {
        c++;
      }
    });
    this.nachliefernCheckedCounter = c;
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.nachliefernChecked = {};
    this.messages.forEach((m, idx) => {
      this.nachliefernChecked[idx] = false;
    });
  }

/**
 * Beschreibt Methode selectAll und ihren Rückgabevertrag.
 */
  selectAll() {
    Object.keys(this.nachliefernChecked).forEach(k => {
      this.nachliefernChecked[k] = true;
    });
    this.doClose();
  }

/**
 * Beschreibt Methode selectNone und ihren Rückgabevertrag.
 */
  selectNone() {
    Object.keys(this.nachliefernChecked).forEach(k => {
      this.nachliefernChecked[k] = false;
    });
    this.doClose();
  }

/**
 * Beschreibt Methode doClose und ihren Rückgabevertrag.
 */
  doClose() {
    const nachliefernEntries = [];
    Object.keys(this.nachliefernChecked).forEach(k => {
      if (this.nachliefernChecked[k] == true) {
        nachliefernEntries.push(this.messages[k].entry);
      }
    });

    this.dialogRef.close(nachliefernEntries);
  }
}
